import { render, staticRenderFns } from "./InputWithTextareaModal.vue?vue&type=template&id=203089ca&scoped=true"
import script from "./InputWithTextareaModal.vue?vue&type=script&lang=ts"
export * from "./InputWithTextareaModal.vue?vue&type=script&lang=ts"
import style0 from "./InputWithTextareaModal.vue?vue&type=style&index=0&id=203089ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203089ca",
  null
  
)

export default component.exports